<template>
<div class='project-view'>
  <!-- 返回条 -->
  <div class='nav'>
    <!-- <steps :step="step" v-if="true || showSteps" /> -->
    <router-link class='return-btn' :to="upperPath || '/'" v-if="!tbcMode">
      <i class='ppj-icon-angle-left'></i>{{$t('common.buttons.return')}}
    </router-link>
  </div>

  <router-view class='sub-project-view' v-if='loaded'></router-view>
</div>
</template>

<script>
import StepsComponent from './steps'

export default {
  data() {
    return {
      showSteps: false,
      loaded: false,
      upperPath: null
    }
  },
  computed: {
    project() {
      let id = this.$route.params.id
      return id ? this.$store.state.project.items[id] : null
    },
    step() {
      let vm = this

      if (vm.$route.name === 'project_upload') {
        return 'upload'
      }

      if (vm.project) {
        switch (vm.project.state) {
          case 'uploading':
          case 'converting':
          case 'rendering':
          case 'disting':
          case 'finishing':
          case 'redisting':
            return 'convert'
          case 'halted':
            return 'error'
          case 'completed':
            return 'complete'
        }
      }
      return 'loading'
    }
  },
  components: {
    'steps': StepsComponent
  },
  beforeRouteEnter(to, from, next) {
    // 来自index page的需要重载， location.href 以避免内存堆积
    if (from.name === 'category') {
      location.href = to.fullPath
      return
    }
    next(vm => {
      // vm.upperPath = from.fullPath
      if (to.query.catId) {
        vm.upperPath = `/categories/${to.query.catId}`
      }

      // 如果来于 project_upload, 则需要显示步骤条
      if (to.name === 'project_upload' || from.name === 'project_upload') {
        vm.showSteps = true
        vm.loaded = true
      }

      if (to.params.id) {
        vm.$store.dispatch('project/get', {
          id: to.params.id,
          force: true
        }).then(res => {
          vm.loaded = true
        })
      }
    })
  }
}
</script>

<style lang='scss' scoped>
.project-view {
    padding-left: 3 * $padding-base;
    padding-right: 3 * $padding-base;
    padding-top: 0;

    .nav {
        padding-top: 30px;
        padding-bottom: 20px;
        padding-left: ($page-width-base - $page-width-small) / 2;
        min-height: 66px;

        .return-btn {
            float: left;
        }

        .steps-wrapper + .return-btn {
            position: absolute;
            top: 55px;
        }
    }

    .sub-project-view {
        text-align: center;
        padding: 3 * $padding-base 0;
        min-height: 480px;
        background-color: $color-white-base;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?6f200cef